const B = "/assets";

export const IMG = {
  landingHero: `${B}/73376117a348c2f1ed976eb95db963f4e213d1cf3d3ea69c4622706bd10a8c71.jpeg`,
  nutrition: `${B}/773f84a71362bfddb2a4ebff9b7fc03622db8de08520ca5ceee63d580ec3dc8b.jpeg`,
  yoga: `${B}/04ab6828889e6832e99b1b4f4c4c0a178f5429ede58a4cbb2a2f3904c53458ee.jpeg`,
  taichi: `${B}/5d419cf15fd21e958615fa109fb52b3fb1bc046d0bc567a796a8efaea2d1d5bb.jpeg`,
  strength: `${B}/68ed1a52db95e28075c5498ff9a1fdf7c5f5d3e28c556564abdd06e2d80eeeef.jpeg`,
  conditioning: `${B}/11f9fd103f0bc79600f914b5b16b30e826fddce227aeca804e897420f25488bb.jpeg`,
  progress: `${B}/dc51f85857694d242faa16b45039eada2a324e42f2c0b5cdecb38d0c841208ff.jpeg`,
  membership: `${B}/56254b8f0ff3541b7f4552c3bf073edfac9a87b42bf579f5f1224e34fccd0346.jpeg`,
  meditation: `${B}/b943f72964f21568a1b0d7d79ebba47bdd9623c942518f651d476a165280ea34.jpeg`,
  soul: `${B}/6f4b19f7ddb2eb0b33e830a9b8a2e1d8401ccdb90cb9a86bcb9ce3795607322d.jpeg`,
  padelHero: `${B}/66ea08bb374bdcc435cfd500f32a5330cd6bfd028b64ee0b9dfcfaba99780c38.jpeg`,
};
